import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({
  selector: 'ng-template[tableCell]',
  standalone: true,
})
export class TableCellDef {
  @Input('tableCell') name!: string;
  constructor(public template: TemplateRef<unknown>) {}
}
